import React from 'react'

type Props = {
    icon: React.ReactNode;
    label: string;
    onClick: () => void;
    isExpanded?: boolean;
}

const SideHeaderButton = ({ icon, label, onClick, isExpanded }: Props) => {
    const styledIcon = React.cloneElement(icon as any, {
        className: getIconClass(), // or any additional props you want to pass
        style: { fontSize: "30px" }
    });
    function getIconClass() {
        if (!isExpanded) {
            return "flex justify-center items-center w-full h-full"
        }
        return ""
    }

    function getSpanClassNames() {
        if (isExpanded) {
            return 'text-sm font-semibold';
        }
        return 'text-sm font-semibold hidden';
    }

    function getLinkWidth() {
        if (isExpanded) {
            return 'w-full shadow-xl'
        }
        return 'w-full hover:w-max'
    }

    return (
        <div onClick={onClick} className={`flex items-center cursor-pointer border-solid border-[1px] border-primary space-x-2 z-20 py-[8px] px-[13px] w-full rounded-[8px] [&>span]:hover:inline transition-all bg-primary hover:bg-primary-light text-white ${getLinkWidth()}`} >
            <div className={`${getIconClass()}`}>{styledIcon}</div>
            <span className={getSpanClassNames()}>{label}</span>
        </div>
    )
}

export default SideHeaderButton